import useTranslator from "../../hooks/useTranslator";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import "rc-tooltip/assets/bootstrap.css";
import "react-circular-progressbar/dist/styles.css";
import "react-circular-progressbar/dist/styles.css";
import VectorIcon from "../../assets/img/VectorIcon1.svg";
import Twotone2 from "../../assets/img/ic_twotone-euro2.svg";
import UserIcon from "../../assets/img/user-icon-gray.svg";
import moreInfoimg from "../../assets/img/moreInfoimg.svg";
import { useContext, useEffect, useState } from "react";
import {
  calculateEffortRatePercentageTenant,
  convertCurrencyFormat,
  getRentPercentage,
  haveValue,
  toast,
  getUserDisplayName,
} from "../../helper/common";
import moment from "moment";
import TotalSalaryModal from "./TotalSalaryModal";
import UpdatedIncomeSourceModal from "./UpdateIncomeSourceModal";
import ConnectBankCard from "./ConnectBankCard";
import FinancialInfoModal from "./FinancialInfoModal";
import useServiceFile from "../../hooks/useServiceFile";
import { navigateToTenantDocument } from "../../Utils/tenantDocumentNavigation";
import LandLordContext from "../../context/landlord/LandLordContext";
import AuthContext from "../../context/auth/AuthContext";
import BankModal from "../../pages/onboarding/BankModal";
import LandlordBankCard from "./LandlordBankCard";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { WORKSPACE_ROLES_CAPABILITIES } from "../../Utils/workspaceRoleCapabilities";
import ButtonActionTooltip from "../ErrorModal/ButtonActionTooltip";
import { namesMatch } from "../../Utils/nameMatcher";
import {
  Badge,
  Button,
  Card,
  Icon,
  InfoList,
  Notice,
  TextField,
} from "../design";
import {
  isApplicationGuarantor,
  resolveEffortRateSettings,
} from "../../helper/effortRateSettings";
import "./detailsSkor.css";

const DetailsSkor = (props) => {
  const {
    user = {},
    combinedIncome = 0,
    effortObj,
    handleSaveEffortRateData = () => {},
    userIncome = {},
    gurantorsIncome = {},
    handleIncomeChange,
    totalIncomeModal,
    setTotalIncomeModal,
    showReportIcons,
    handleFinancialIncomeChange,
    selectedFinancialIncomeSourceData,
    selectedSources,
    setSelectedSources,
    loadFullInfo,
    isGuarantor,
    paymentScoreLoading,
    setPaymentScoreLoading,
    Bankshow,
    setBankshow,
    reconnectFlow,
    setReconnectFlow,
    updateTenantData,
    scoreValue,
    setScoreValue,
    getAnalysisDetails,
    financial_info_errors,
    setFinancial_info_errors,
    profileId,
    excluded_income_source_ids,
    isFromReport = false,
    effortRateType,
    setEffortRateType,
    totalGuarantorIncome,
    showEffortRateCalcuator,
    setShowEffortRateCalcuator,
    fullinfo,
    fullInfoForGurantor,
    guarantor_id,
    totalGurantorIncomeForTable,
    combinedIncomeForTable,
    llShowOnly,
    reportMode = false,
    hideEffortRate = false,
    bankStatementClassification = null,
    processing = false,
    readOnly = false,
  } = props;
  const { _t } = useTranslator();
  const [isHovered, setIsHovered] = useState(false);
  const {
    getTinkReportData,
    sendFinancialInfoRemainder,
    deleteCustomIncomeSource,
  } = useContext(LandLordContext);
  const { setLoading, user: originalUser } = useContext(AuthContext);
  const isUserTenantCheck =
    user?.role != "tenant" && user?.role != "emailTenant";

  const [updateIncomeSourceModal, setUpdateIncomeSourceModal] = useState(false);
  const maxValue = 1000;
  const [value, setValue] = useState(0);
  const [ieScore, setIeScore] = useState(null);

  const [isSkorExpired, setIsSkorExpired] = useState(false);
  const [updateSourceObj, setUpdateSourceObj] = useState([]);
  const [financialInfoModal, setFinancialInfoModal] = useState(false);
  // Prefetch the bank-score source file on profile load so the modal
  // shows the "Scored from …" line instantly on open (cached in hook).
  const prefetchedBankFile = useServiceFile(
    user?._id,
    "BANK_SCORE",
    true,
    isGuarantor
  );
  // Source for the bank score line. Statement when the score came from an
  // uploaded statement (provider CSV or BANK_SCORE file with
  // operation bank_statement_upload), otherwise a bank connection.
  const bankProviderName =
    user?.bank_details?.userDataByProvider?.[0]?.providerName ?? "";
  const isBankStatementSource =
    bankProviderName === "Uploaded from CSV" ||
    prefetchedBankFile?.metadata?.operation === "bank_statement_upload";
  const bankAccountLast4 =
    user?.bank_details?.userDataByProvider?.[0]?.accounts?.[0]?.iban?.slice(
      -4
    ) ?? "";
  const bankSourceDate = prefetchedBankFile?.created_at
    ? moment(prefetchedBankFile.created_at)
    : haveValue(user?.bankVerificationDate)
      ? moment(user.bankVerificationDate)
      : null;
  const hasBankSourceDate = Boolean(bankSourceDate?.isValid());
  const [sendRemainderLoading, setSendRemainderLoading] = useState(false);
  const [propertyRent, setPropertyRent] = useState("");

  const handleDeleteCustomIncome = async (customSourceId, userType, userId) => {
    const id =
      (fullinfo?._id?.$oid || fullinfo?._id) ??
      fullinfo?.tenant_id?.profileId ??
      profileId;
    const tenantId = fullinfo?.tenantid?._id;
    const targetIsGuarantor = userType === "guarantor" || isGuarantor;
    const specificGuarantorId =
      targetIsGuarantor && userId ? userId : guarantor_id;
    try {
      const payload = {
        tenantid: tenantId,
        target_type: targetIsGuarantor ? "guarantor" : "tenant",
        guarantor_id: targetIsGuarantor ? specificGuarantorId : undefined,
      };
      const res = await deleteCustomIncomeSource(id, customSourceId, payload);
      if (res?.status === "success") {
        toast.success(
          _t("customIncomeDeleted", "Custom income deleted successfully")
        );
        await loadFullInfo();
      } else {
        toast.error(
          _t("failedToDeleteCustomIncome", "Failed to delete custom income")
        );
      }
    } catch (err) {
      toast.error(
        _t("failedToDeleteCustomIncome", "Failed to delete custom income")
      );
    }
  };

  useEffect(() => {
    if (haveValue(scoreValue) && haveValue(maxValue)) {
      setValue((scoreValue / maxValue) * 100);

      const dateToCheck = haveValue(user?.bankVerificationDate)
        ? user.bankVerificationDate
        : user?.created_at;

      const expiryDate = moment(dateToCheck).add(2, "months");

      const isExpired = expiryDate.isBefore(moment(), "day");

      setIsSkorExpired(isExpired);
    }
  }, [scoreValue]);

  useEffect(() => {
    if (!haveValue(ieScore) && user?.ie_verified) {
      calculateIeScore();
    }
    const temp_score = user?.paymentScores?.creditScore?.value;
    if (haveValue(temp_score) && !paymentScoreLoading) {
      setScoreValue(temp_score);
    } else {
      setScoreValue(null);
    }
  }, [user, ieScore, paymentScoreLoading]);

  const calculateIeScore = () => {
    var totalScore = (user?.paymentScores?.creditScore?.value || 0) / 2;

    if (user?.ie_verified) {
      if (totalScore >= 600) {
        totalScore += 200;
      } else {
        totalScore += 400;
      }
    }
    if (totalScore > 850) {
      totalScore = 850;
    }
    setIeScore(totalScore);
  };

  const getProgressColor = (percentage) => {
    if (percentage < 20) return "#F3483E";
    if (percentage < 40) return "#F77841";
    if (percentage < 60) return "#F8E002";
    if (percentage < 80) return "#99DE04";
    return "#05C200";
  };

  const Handle = Slider.Handle;

  const returnSkorStatus = () => {
    const skor = user?.paymentScores?.creditScore?.value;
    if (skor <= 200) {
      return <h2 className="dsk-status UnstableText">{_t("unstable")}</h2>;
    } else if (skor >= 201 && skor <= 400) {
      return <h2 className="dsk-status VariableText">{_t("variable")}</h2>;
    } else if (skor >= 401 && skor <= 600) {
      return <h2 className="dsk-status StableText">{_t("stable")}</h2>;
    } else if (skor >= 601 && skor <= 800) {
      return <h2 className="dsk-status ReliableText">{_t("reliable")}</h2>;
    } else if (skor >= 800) {
      return (
        <h2 className="dsk-status ExtremelyText">{_t("extremelyReliable")}</h2>
      );
    }
  };

  const [efforRateLocal, setEfforRateLocal] = useState(35);
  const [effortRateData, setEffortRateData] = useState(effortObj);
  const [allGuarantorSources, setAllGuarantorSources] = useState([]);

  useEffect(() => {
    setEffortRateData(effortObj);

    let effortRateType = "tenant";
    let effortRateValue =
      effortObj?.effort_rate ??
      originalUser?.current_workspace?.default_effort_rate ??
      35;

    if (
      llShowOnly &&
      (fullinfo?.effort_rate_data || fullInfoForGurantor?.effort_rate_data)
    ) {
      if (isGuarantor) {
        const personId = guarantor_id ?? user?._id;
        const guarantorData = resolveEffortRateSettings(
          fullInfoForGurantor?.effort_rate_data ?? fullinfo?.effort_rate_data,
          personId,
          true
        );

        effortRateType = guarantorData?.effort_rate_type ?? "guarantor";
        effortRateValue =
          guarantorData?.effort_rate_percentage ??
          effortObj?.effort_rate ??
          originalUser?.current_workspace?.default_effort_rate ??
          35;
      } else {
        const personId = user?._id;
        const participantSettings = resolveEffortRateSettings(
          fullinfo?.effort_rate_data,
          personId,
          isApplicationGuarantor(fullinfo, personId)
        );

        effortRateType =
          participantSettings?.effort_rate_type ??
          fullinfo?.effort_rate_data?.tenant?.effort_rate_type ??
          "tenant";

        effortRateValue =
          participantSettings?.effort_rate_percentage ??
          fullinfo?.effort_rate_data?.tenant?.effort_rate_percentage ??
          effortObj?.effort_rate ??
          originalUser?.current_workspace?.default_effort_rate ??
          35;
      }
    } else {
      effortRateType =
        haveValue(user?.effort_rate_type) && !isGuarantor
          ? user?.effort_rate_type
          : isGuarantor
            ? "guarantor"
            : "tenant";

      effortRateValue = effortObj?.effort_rate ?? 35;
    }

    setEffortRateType(effortRateType);
    setEfforRateLocal(effortRateValue);
  }, [
    user,
    effortObj?.effort_rate,
    isGuarantor,
    guarantor_id,
    fullinfo?.effort_rate_data,
    fullInfoForGurantor?.effort_rate_data,
  ]);

  useEffect(() => {
    const guarantorSources = gurantorsIncome?.map((item) => ({
      _id: item?.all_sources?._id,
      all_sources: item?.all_sources,
      current_selected: item?.source,
      current_income_mode: item?.source_mode,
      type: "guarantor",
    }));
    setAllGuarantorSources(guarantorSources);
  }, [gurantorsIncome]);

  useEffect(() => {
    setEffortRateData(
      calculateEffortRatePercentageTenant(combinedIncome, user, efforRateLocal)
    );
  }, [efforRateLocal, combinedIncome]);

  // in your onChange handler
  const handleChangeEffortRate = (val) => {
    setEfforRateLocal(val);
  };

  const handleChangeEffortRateApiCall = (data) => {
    if (reportMode) return;
    const _data = {
      effort_rate_percentage: data,
      type: "percentage",
      tenant_id: user?._id,
    };
    handleSaveEffortRateData(_data);
  };

  const handleUpdateEffortRateType = (data) => {
    const _data = {
      effort_rate_type: data,
      type: "effortRateType",
      tenant_id: user?._id,
    };
    handleSaveEffortRateData(_data);
  };

  const handleOpenFinancialInfoModal = () => {
    if (
      haveValue(user?.tenant_extra_field_id?.tink_report_data) &&
      Object.keys(user?.tenant_extra_field_id?.tink_report_data).length > 0 &&
      user?.tenant_extra_field_id?.tink_report_data?.status != "failed"
    ) {
      setFinancialInfoModal(true);
    } else {
      setLoading(true);
      getTinkReportData(user?._id)
        .then(async (res) => {
          await loadFullInfo();
          setLoading(false);
          setFinancialInfoModal(true);
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  };

  const handleSendRemainder = async (purpose) => {
    try {
      setSendRemainderLoading(true);
      let payload = {
        tenant_id: user?._id,
      };
      if (purpose === "forExpiryFinancialData") {
        payload.purpose = "forExpiryFinancialData";
      }
      const res = await sendFinancialInfoRemainder(payload);
      if (res?.success) {
        toast.success(
          _t("remainderSent", "Text used if to send remainder success")
        );
      } else {
        toast.error(
          _t("failedToSendRemainder", "Text used if failed to send remainder")
        );
      }
    } catch (error) {
      toast.error(
        _t("failedToSendRemainder", "Text used if failed to send remainder")
      );
    } finally {
      setSendRemainderLoading(false);
    }
  };

  const effortRateToggleOptions = ["tenant", "guarantor", "both"];

  const handleClick = (option) => {
    setEffortRateType(option);
    if (!reportMode) {
      handleUpdateEffortRateType(option);
    }
  };

  const getEffortColor = (value) => {
    if (value >= 1 && value <= 35) return "#99DE04"; // green
    if (value > 35 && value <= 45) return "#F77841"; // yellow-orange
    if (value > 45) return "#F3483E"; // red
    return "#7F7F7F"; // fallback
  };

  const min = 10,
    max = 50;
  // same limits as getEffortColor: up to 35 fine, up to 45 stretching
  const effortZone =
    efforRateLocal <= 35 ? "ok" : efforRateLocal <= 45 ? "stretch" : "risk";

  useEffect(() => {
    if (haveValue(propertyRent)) {
      const combinedPercentage = getRentPercentage(
        combinedIncomeForTable,
        propertyRent
      )?.exactValue;

      // clamp between 10 and 50
      const cappedPercentage = Math.min(Math.max(combinedPercentage, 10), 50);

      handleChangeEffortRate(cappedPercentage);
      handleChangeEffortRateApiCall(cappedPercentage);
    }
  }, [propertyRent]);

  const isProfileOutdated =
    !llShowOnly && !!(user?.profile_outdated || user?.is_outdated);

  const accountHolderName =
    user?.bank_details?.userDataByProvider?.[0]?.accounts?.[0]?.holderName;
  const isBankStatement =
    user?.bank_details?.userDataByProvider?.[0]?.providerName ===
    "Uploaded from CSV";
  const profileUserName = getUserDisplayName(user);
  let namesMatched = true;

  if (isBankStatement && haveValue(accountHolderName)) {
    const matchResult = namesMatch(accountHolderName, profileUserName);
    namesMatched = matchResult.matched;
  }

  return (
    <>
      <div
        className={`row mainEffortRateWrapper ${
          hideEffortRate ? "details-skor--financial-only" : ""
        }`}
      >
        {!hideEffortRate && (
          <div className="col-md-6 details-skor__effort-rate">
            <Card
              as="div"
              className="dsk-card"
              title={_t("setEffortRate")}
              actions={
                !showEffortRateCalcuator && (
                  <div className="dsk-toggle">
                    {effortRateToggleOptions.map((option) => {
                      const isDisabled =
                        user?.gurantor_id?.filter(
                          (val) => val?.forensic_status === "COMPLETED"
                        )?.length === 0 &&
                        [isGuarantor ? "tenant" : "guarantor", "both"].includes(
                          option
                        );

                      return (
                        <div
                          style={{ display: "inline-block" }}
                          data-tooltip-id={
                            isDisabled ? "button-action-tooltip" : undefined
                          }
                          key={option}
                        >
                          <Button
                            size="sm"
                            variant={
                              effortRateType === option ? "primary" : "ghost"
                            }
                            disabled={isDisabled}
                            className={isDisabled ? "pe-none" : ""}
                            onClick={() => !isDisabled && handleClick(option)}
                          >
                            {_t(option)}
                          </Button>

                          {isDisabled && <ButtonActionTooltip />}
                        </div>
                      );
                    })}
                  </div>
                )
              }
            >
              <div className="d-flex justify-content-between flex-wrap w-100">
                {!llShowOnly ? (
                  <p className="dsk-text">
                    {_t("landlordsTypicallyPreferEffortRatesBelow")}
                  </p>
                ) : (
                  <div className="d-flex align-items-center justify-content-between w-100 flex-wrap">
                    <p className="dsk-text">
                      {_t("keyFinancialMetricsForYourRentalSituation")}
                    </p>

                    {showEffortRateCalcuator && (
                      <div className="property-rent-field">
                        {_t("propertyRent")}:
                        <TextField
                          id="property-rent"
                          size="sm"
                          icon="€"
                          trailing={<span>/mo</span>}
                          placeholder="0"
                          type="text"
                          value={propertyRent}
                          onChange={(e) => {
                            const value = e.target.value;

                            if (/^\d*$/.test(value)) {
                              setPropertyRent(value);
                            }
                          }}
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
              {showEffortRateCalcuator ? (
                <div className="effort-rate-table">
                  <div className="effort-rate-table-heading">
                    <p
                      className="text-left"
                      onClick={() => setTotalIncomeModal(true)}
                    >
                      {_t("category")}
                    </p>
                    <p>{_t("monthlyNetIncome")}</p>
                    <p>{_t("effortRate")}</p>
                  </div>
                  <div
                    className={`effort-rate-table-info ${
                      isGuarantor ? "text_disabled" : ""
                    }`}
                  >
                    <p
                      onClick={() => {
                        if (reportMode) return;
                        const sourceObj = isGuarantor
                          ? allGuarantorSources
                          : [
                              {
                                _id: userIncome?.all_sources?._id,
                                all_sources: userIncome?.all_sources,
                                current_selected: userIncome?.source,
                                current_income_mode: userIncome?.source_mode,
                                type: "tenant",
                              },
                            ];
                        setUpdateSourceObj(sourceObj);
                        setUpdateIncomeSourceModal(true);
                      }}
                      className={`d-flex justify-content-start gap-2 align-items-center ${
                        reportMode ? "" : "cursor-pointer"
                      } ${!isGuarantor ? "text-decoration-underline" : ""}`}
                    >
                      {_t("tenant")}
                      <img
                        className="Imagerutate ImageSizeSet"
                        src={VectorIcon}
                        alt="Vector Icon"
                      />
                    </p>
                    <p>
                      €
                      {convertCurrencyFormat(
                        isGuarantor
                          ? totalGurantorIncomeForTable
                          : userIncome?.amount
                      )}
                    </p>
                    <p
                      style={{
                        color: getEffortColor(
                          getRentPercentage(
                            isGuarantor
                              ? totalGurantorIncomeForTable
                              : userIncome?.amount,
                            propertyRent
                          )?.roundValue
                        ),
                      }}
                    >
                      {propertyRent
                        ? `${
                            getRentPercentage(
                              isGuarantor
                                ? totalGurantorIncomeForTable
                                : userIncome?.amount,
                              propertyRent
                            )?.roundValue ?? "0"
                          }%`
                        : "-"}
                    </p>
                  </div>
                  <div
                    className={`effort-rate-table-info ${
                      isGuarantor
                        ? ""
                        : user?.gurantor_id?.filter(
                              (val) => val?.forensic_status === "COMPLETED"
                            )?.length == 0
                          ? "text_disabled"
                          : ""
                    }`}
                  >
                    <p
                      onClick={() => {
                        if (reportMode) return;
                        const sourceObj = isGuarantor
                          ? [
                              {
                                _id: userIncome?.all_sources?._id,
                                all_sources: userIncome?.all_sources,
                                current_selected: userIncome?.source,
                                current_income_mode: userIncome?.source_mode,
                                type: "tenant",
                              },
                            ]
                          : allGuarantorSources;
                        setUpdateSourceObj(sourceObj);
                        setUpdateIncomeSourceModal(true);
                      }}
                      className={`d-flex justify-content-start gap-2 align-items-center ${
                        reportMode ? "" : "cursor-pointer"
                      } ${
                        isGuarantor
                          ? "text-decoration-underline"
                          : user?.gurantor_id?.filter(
                                (val) => val?.forensic_status === "COMPLETED"
                              )?.length > 0
                            ? "text-decoration-underline"
                            : ""
                      }`}
                    >
                      {_t("guarantors")}
                      <img
                        className="Imagerutate ImageSizeSet"
                        src={VectorIcon}
                        alt="Vector Icon"
                      />
                    </p>
                    <p>
                      €
                      {convertCurrencyFormat(
                        isGuarantor
                          ? userIncome?.amount
                          : totalGurantorIncomeForTable
                      )}
                    </p>
                    <p
                      style={{
                        color: getEffortColor(
                          getRentPercentage(
                            isGuarantor
                              ? userIncome?.amount
                              : totalGurantorIncomeForTable,
                            propertyRent
                          )?.roundValue ?? "0"
                        ),
                      }}
                    >
                      {propertyRent
                        ? `${
                            getRentPercentage(
                              isGuarantor
                                ? userIncome?.amount
                                : totalGurantorIncomeForTable,
                              propertyRent
                            )?.roundValue ?? "0"
                          }%`
                        : "-"}
                    </p>
                  </div>
                  <div
                    className={`effort-rate-table-info border-0 ${
                      user?.gurantor_id?.filter(
                        (val) => val?.forensic_status === "COMPLETED"
                      )?.length == 0
                        ? "text_disabled"
                        : ""
                    }`}
                  >
                    <p className="text-left">{_t("combined")}</p>
                    <p>€{convertCurrencyFormat(combinedIncomeForTable)}</p>
                    <p
                      style={{
                        color: getEffortColor(
                          getRentPercentage(
                            combinedIncomeForTable,
                            propertyRent
                          )?.roundValue
                        ),
                      }}
                    >
                      {propertyRent
                        ? `${
                            getRentPercentage(
                              combinedIncomeForTable,
                              propertyRent
                            )?.roundValue ?? "0"
                          }%`
                        : "-"}
                    </p>
                  </div>
                  {llShowOnly && showEffortRateCalcuator && (
                    <div className="dsk-card__footer">
                      <Button
                        variant="secondary"
                        size="sm"
                        iconStart={<Icon name="chevronLeft" size={16} />}
                        onClick={() => setShowEffortRateCalcuator(false)}
                      >
                        {_t("backToPreviousView")}
                      </Button>
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  <div>
                    <div className={`dsk-meter is-${effortZone}`}>
                      <Slider
                        min={min}
                        max={max}
                        value={efforRateLocal}
                        onChange={handleChangeEffortRate}
                        onChangeComplete={handleChangeEffortRateApiCall}
                        draggableTrack={true}
                      />
                      <div className="dsk-meter__labels">
                        <span className="dsk-meter__label dsk-meter__label--ok">
                          {_t("affordable")}
                        </span>
                        <span className="dsk-meter__label dsk-meter__label--stretch">
                          {_t("stretching")}
                        </span>
                        <span className="dsk-meter__label dsk-meter__label--risk">
                          {_t("risk")}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="row effortRateIncomeWrapper vw-mt-4">
                    <div className="col-md-6">
                      <div className="dsk-stat">
                        <div className="d-flex justify-content-between align-items-end w-100">
                          <div className="dsk-stat__body">
                            <div className="dsk-stat__icon">
                              <img
                                src={Twotone2}
                                alt="Vector Icon"
                                className="TwotoneIcon"
                              />
                            </div>
                            <div style={{ width: "100%" }}>
                              <p className="dsk-label d-flex align-items-center gap-2">
                                <span
                                  onClick={() => {
                                    if (!llShowOnly || reportMode) {
                                      return;
                                    }
                                    const sourceObj =
                                      effortRateType === "tenant" || isGuarantor
                                        ? //  only tenant income
                                          [
                                            {
                                              _id: userIncome?.all_sources?._id,
                                              all_sources:
                                                userIncome?.all_sources,
                                              current_selected:
                                                userIncome?.source,
                                              current_income_mode:
                                                userIncome?.source_mode,
                                              type: isGuarantor
                                                ? "guarantor"
                                                : "tenant",
                                            },
                                          ]
                                        : effortRateType === "guarantor"
                                          ? // only guarantors income
                                            allGuarantorSources
                                          : // both tenant and guarantors income
                                            [
                                              {
                                                _id: userIncome?.all_sources
                                                  ?._id,
                                                all_sources:
                                                  userIncome?.all_sources,
                                                current_selected:
                                                  userIncome?.source,
                                                current_income_mode:
                                                  userIncome?.source_mode,
                                                type: "tenant",
                                              },
                                              ...allGuarantorSources,
                                            ];
                                    setUpdateSourceObj(sourceObj);
                                    setUpdateIncomeSourceModal(true);
                                  }}
                                  className={`d-flex align-items-center custom-gap-1 ${
                                    llShowOnly && !reportMode
                                      ? "text-decoration-underline cursor-pointer"
                                      : ""
                                  }`}
                                >
                                  {_t("averageMonthlyNetIncome")}
                                  <img
                                    src="/images/arrow-right.svg"
                                    alt="Vector Icon"
                                    className="arrow-back-icon"
                                  />
                                </span>
                                <div className="d-flex align-items-center gap-1">
                                  <img
                                    src={UserIcon}
                                    alt="Vector Icon"
                                    className="vactorImg vactorImg1"
                                  />
                                  <p className="dsk-label">
                                    {(() => {
                                      const tenantCount =
                                        effortRateType === "tenant" ||
                                        effortRateType === "both"
                                          ? 1
                                          : 0;

                                      let guarantorCount =
                                        effortRateType === "guarantor" ||
                                        effortRateType === "both"
                                          ? (user?.gurantor_id?.length ?? 0)
                                          : 0;
                                      if (isGuarantor) {
                                        guarantorCount = 1;
                                      }

                                      return tenantCount + guarantorCount;
                                    })()}
                                  </p>
                                </div>
                              </p>
                              <div className="d-flex justify-content-between align-items-center">
                                <p className="dsk-number">
                                  €{convertCurrencyFormat(combinedIncome ?? 0)}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="dsk-stat">
                        <div className="d-flex justify-content-between align-items-center w-100">
                          <div className="dsk-stat__body">
                            <div className="dsk-stat__icon">
                              <img
                                src={"/images/max-rent-icon.svg"}
                                alt="Vector Icon"
                                className="TwotoneIcon"
                              />
                            </div>
                            <div className="profile_heading_width ">
                              <p className="dsk-label d-flex align-items-center custom-gap-2">
                                {_t("monthlyPayment")}

                                {llShowOnly && (
                                  <>
                                    <img
                                      data-tooltip-id="details-skor-tooltip"
                                      src={moreInfoimg}
                                      alt="Vector Icon"
                                      className="vactorImg vactorImg1"
                                    />
                                    <ReactTooltip
                                      id="details-skor-tooltip"
                                      place="bottom"
                                      noArrow
                                      className="react-tooltip-styling details-skor-tooltip"
                                      render={() => (
                                        <p>
                                          {_t(
                                            "toEnsureFinacialStabilityWeRecommendAMaximumEffortRateOf35StayingWithinThisThresholdIsStandardPraticeInSpainToEnsureAffordabilityAndMinimizeRiskForBothParties"
                                          )}
                                        </p>
                                      )}
                                    />
                                  </>
                                )}
                              </p>
                              <div className="d-flex gap-2 align-items-center">
                                <p className="dsk-number">
                                  €
                                  {!Number.isNaN(effortRateData?.effort_amount)
                                    ? convertCurrencyFormat(
                                        Math.round(
                                          Number(effortRateData.effort_amount)
                                        )
                                      )
                                    : 0}
                                </p>
                                <p
                                  style={{
                                    fontWeight: "700",
                                    color: getEffortColor(efforRateLocal),
                                  }}
                                  className="dsk-label"
                                >
                                  {`(${Math.round(efforRateLocal)}% ${_t(
                                    "effortRate"
                                  )})`}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {llShowOnly && (
                      <div className="dsk-card__footer">
                        <Button
                          variant="secondary"
                          size="sm"
                          iconEnd={<Icon name="chevronRight" size={16} />}
                          onClick={() => setShowEffortRateCalcuator(true)}
                        >
                          {_t("effortRateCalculator")}
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </Card>
          </div>
        )}
        <div className="col-md-6 details-skor__financial">
          {haveValue(scoreValue) ? (
            <div
              className="dsk-hover-area"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <Card
                as="div"
                className="dsk-card dsk-card--financial meterMainContainer"
                title={_t("financialSkor")}
                actions={
                  !llShowOnly &&
                  !readOnly &&
                  namesMatched &&
                  !isSkorExpired && (
                    <div
                      style={{ display: "inline-block" }}
                      className="flex-shrink-0 hideOnMobile"
                      data-tooltip-id={
                        isProfileOutdated
                          ? "reconnect-bank-blocked-tooltip"
                          : undefined
                      }
                    >
                      <Button
                        size="sm"
                        disabled={isProfileOutdated}
                        onClick={() => {
                          if (isProfileOutdated) return;
                          setBankshow(true);
                          setReconnectFlow(true);
                        }}
                      >
                        {_t("reconnectBank")}
                      </Button>
                      <ReactTooltip
                        id="reconnect-bank-blocked-tooltip"
                        place="top"
                        className="react-tooltip-styling"
                        render={() =>
                          isProfileOutdated ? (
                            <p>
                              {_t(
                                "profileOutdatedRenewFirst",
                                "Your profile is outdated. Please renew your profile first."
                              )}
                            </p>
                          ) : null
                        }
                      />
                    </div>
                  )
                }
              >
                {/* expired: the notice floats over the faded gauge, so the card keeps its height */}
                <div className="dsk-body">
                  {isSkorExpired && namesMatched && (
                    <Notice
                      tone="warning"
                      layout="stack"
                      className="dsk-expired"
                      title={_t("expired")}
                      action={
                        showReportIcons &&
                        (llShowOnly &&
                        WORKSPACE_ROLES_CAPABILITIES?.tenants?.interactionRoles?.includes(
                          originalUser?.current_workspace_role
                        ) ? (
                          <Button
                            size="sm"
                            loading={sendRemainderLoading}
                            onClick={() =>
                              handleSendRemainder("forExpiryFinancialData")
                            }
                          >
                            {sendRemainderLoading
                              ? `${_t("sending")}...`
                              : _t("sendRemainder")}
                          </Button>
                        ) : !readOnly ? (
                          <span
                            data-tooltip-id={
                              isProfileOutdated
                                ? "reconnect-bank-expired-blocked-tooltip"
                                : undefined
                            }
                          >
                            <Button
                              size="sm"
                              disabled={isProfileOutdated}
                              onClick={() => {
                                if (isProfileOutdated) return;
                                setBankshow(true);
                                setReconnectFlow(true);
                              }}
                            >
                              {_t("reconnectBank")}
                            </Button>
                            <ReactTooltip
                              id="reconnect-bank-expired-blocked-tooltip"
                              place="top"
                              className="react-tooltip-styling"
                              render={() =>
                                isProfileOutdated ? (
                                  <p>
                                    {_t(
                                      "profileOutdatedRenewFirst",
                                      "Your profile is outdated. Please renew your profile first."
                                    )}
                                  </p>
                                ) : null
                              }
                            />
                          </span>
                        ) : null)
                      }
                    >
                      {llShowOnly
                        ? _t(
                            "skorValidityForThisTenantHasBeenExpiredSendAReminderToTheTenantToReverifyTheirBankToContinueBeingSkored"
                          )
                        : _t(
                            "yourFinancialSkorVallidityHasExpiredPleaseReVerifyYourBankToContiueBeingSkored"
                          )}
                    </Notice>
                  )}
                  <div className="row">
                    {namesMatched ? (
                      <>
                        <div className="col-5 col-md-6">
                          <div
                            style={{
                              position: "relative",
                              ...(isProfileOutdated || isSkorExpired
                                ? { filter: "grayscale(1)", opacity: 0.5 }
                                : {}),
                            }}
                            className="skorSetWrapper"
                          >
                            {/* SVG Gradient (hidden but used via URL) */}
                            <svg
                              style={{
                                height: "0",
                                position: "absolute",
                                top: "0",
                              }}
                            >
                              <defs>
                                <linearGradient
                                  id="progressGradient"
                                  x1="0%"
                                  y1="0%"
                                  x2="100%"
                                  y2="0%"
                                >
                                  <stop
                                    offset="100%"
                                    stopColor={getProgressColor(value)}
                                  />
                                </linearGradient>
                              </defs>
                            </svg>
                            <div
                              // className="skorr"
                              className={
                                llShowOnly && !reportMode
                                  ? "skorr cursor-pointer"
                                  : "skorr"
                              }
                              onClick={() => {
                                if (
                                  llShowOnly &&
                                  !reportMode &&
                                  WORKSPACE_ROLES_CAPABILITIES?.tenants?.interactionRoles?.includes(
                                    originalUser?.current_workspace_role
                                  ) &&
                                  user?.bank_details?.userDataByProvider?.[0]
                                    ?.providerName !== "Uploaded from CSV"
                                )
                                  handleOpenFinancialInfoModal();
                              }}
                            >
                              <CircularProgressbarWithChildren
                                value={value}
                                maxValue={100}
                                circleRatio={0.78}
                                styles={buildStyles({
                                  rotation: 0.61,
                                  strokeLinecap: "round",
                                  trailColor: "#e6f0e9",
                                  textColor: "#1c1c1c",
                                  pathTransitionDuration: 0.5,
                                  pathColor:
                                    isProfileOutdated || isSkorExpired
                                      ? "#B8B8B8"
                                      : getProgressColor(value),
                                })}
                              >
                                <div className="skills">
                                  <div className="dsk-score">
                                    <div
                                      className={`dsk-score__value ${
                                        isProfileOutdated || isSkorExpired
                                          ? "is-muted"
                                          : ""
                                      }`}
                                    >
                                      {scoreValue}
                                    </div>
                                    <div className="skoroutoftext dsk-score__max">
                                      /{maxValue}
                                    </div>
                                  </div>
                                  <div className="skoreset">
                                    <div className="skorstart dsk-score__tick">
                                      0
                                    </div>
                                    <div className="skorend dsk-score__tick">
                                      {maxValue}
                                    </div>
                                  </div>
                                </div>
                              </CircularProgressbarWithChildren>
                            </div>
                          </div>
                        </div>

                        <div
                          className="col-7 col-md-6 skorSetDetailsWrapper"
                          style={
                            isProfileOutdated || isSkorExpired
                              ? { filter: "grayscale(1)", opacity: 0.5 }
                              : undefined
                          }
                        >
                          <div>
                            <p className="dsk-label">{_t("scoreStatus")}:</p>
                            {returnSkorStatus()}
                          </div>
                          <div className="row mb-2 about-finical-skor">
                            <div className="col-6">
                              <p className="dsk-label">{_t("createdOn")}:</p>
                              <p className="dsk-value">
                                {moment(
                                  haveValue(user?.bankVerificationDate)
                                    ? user?.bankVerificationDate
                                    : user?.created_at
                                ).format("DD-MM-YYYY")}
                              </p>
                            </div>
                            <div className="col-6">
                              <p className="dsk-label">{_t("validTill")}:</p>
                              <p className="dsk-value">
                                {moment(
                                  haveValue(user?.bankVerificationDate)
                                    ? user?.bankVerificationDate
                                    : user?.created_at
                                )
                                  .add(2, "months")
                                  .format("DD-MM-YYYY")}
                              </p>
                            </div>
                          </div>
                          <div className="about-finical-skor">
                            <p className="dsk-label">{_t("accountHolder")}:</p>
                            <p className="dsk-value">
                              {haveValue(
                                user?.bank_details?.userDataByProvider[0]
                                  ?.accounts[0]?.holderName
                              )
                                ? user?.bank_details?.userDataByProvider[0]
                                    ?.accounts[0]?.holderName
                                : `${user?.fname} ${user?.lname}`}
                            </p>
                          </div>

                          <div className="bank-account-text-wrapper">
                            {user?.ie_verified &&
                            !haveValue(
                              user?.paymentScores?.creditScore?.value
                            ) ? (
                              <p className="dsk-label">
                                {_t("skorBasedOnIEProfile")}{" "}
                              </p>
                            ) : (
                              <p className="dsk-label">
                                {_t("source")}:{" "}
                                {isBankStatementSource ? (
                                  <>
                                    {prefetchedBankFile ? (
                                      <Button
                                        variant="link"
                                        onClick={() =>
                                          navigateToTenantDocument({
                                            tenantId: user?._id,
                                            isGuarantor,
                                            service: "BANK_SCORE",
                                            serviceFile: prefetchedBankFile,
                                          })
                                        }
                                      >
                                        {_t("bankStatement")} ›
                                      </Button>
                                    ) : (
                                      _t("bankStatement")
                                    )}
                                    {hasBankSourceDate && (
                                      <>
                                        {" "}
                                        · {_t("uploadedOn")}{" "}
                                        {bankSourceDate.format("DD-MM-YYYY")}
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {_t("bankConnection")}
                                    {haveValue(bankAccountLast4) && (
                                      <>
                                        {" "}
                                        · {_t("account")} ···{bankAccountLast4}
                                      </>
                                    )}
                                    {hasBankSourceDate && (
                                      <>
                                        {" "}
                                        · {_t("connected")}{" "}
                                        {bankSourceDate.format("DD-MM-YYYY")}
                                      </>
                                    )}
                                  </>
                                )}
                              </p>
                            )}
                            {llShowOnly &&
                              user?.bank_details?.userDataByProvider?.[0]
                                ?.providerName !== "Uploaded from CSV" &&
                              (isSkorExpired ? (
                                <div
                                  class={`meterGifWrapper w-100 d-flex justify-content-end align-items-center`}
                                >
                                  <img src="/images/gif-image.svg" />
                                </div>
                              ) : !isHovered ? (
                                <div
                                  class={`meterGifWrapper w-100 d-flex justify-content-end align-items-center`}
                                  onClick={() => {
                                    if (
                                      llShowOnly &&
                                      !reportMode &&
                                      !isSkorExpired &&
                                      WORKSPACE_ROLES_CAPABILITIES?.tenants?.interactionRoles?.includes(
                                        originalUser?.current_workspace_role
                                      )
                                    )
                                      handleOpenFinancialInfoModal();
                                  }}
                                >
                                  <img src="/gif/meter.gif" />
                                </div>
                              ) : (
                                <div className="dsk-skor-details w-100 d-flex justify-content-end align-items-center">
                                  <Button
                                    size="sm"
                                    iconStart={
                                      <img
                                        src="/images/meter-icon-green-bg.svg"
                                        alt=""
                                      />
                                    }
                                    iconEnd={
                                      <Icon name="arrowRight" size={14} />
                                    }
                                    onClick={() => {
                                      if (
                                        llShowOnly &&
                                        !reportMode &&
                                        !isSkorExpired &&
                                        WORKSPACE_ROLES_CAPABILITIES?.tenants?.interactionRoles?.includes(
                                          originalUser?.current_workspace_role
                                        )
                                      )
                                        handleOpenFinancialInfoModal();
                                    }}
                                  >
                                    {_t("skorDetails")}
                                  </Button>
                                </div>
                              ))}
                          </div>
                          {!llShowOnly && !readOnly && !isSkorExpired && (
                            <div
                              style={{ display: "inline-block" }}
                              className="hideOnDesktop dsk-mobile-action"
                              data-tooltip-id={
                                isProfileOutdated
                                  ? "reconnect-bank-mobile-blocked-tooltip"
                                  : undefined
                              }
                            >
                              <Button
                                size="sm"
                                disabled={isProfileOutdated}
                                onClick={() => {
                                  if (isProfileOutdated) return;
                                  setBankshow(true);
                                  setReconnectFlow(true);
                                }}
                              >
                                {_t("reconnectBank")}
                              </Button>
                              <ReactTooltip
                                id="reconnect-bank-mobile-blocked-tooltip"
                                place="top"
                                className="react-tooltip-styling"
                                render={() =>
                                  isProfileOutdated ? (
                                    <p>
                                      {_t(
                                        "profileOutdatedRenewFirst",
                                        "Your profile is outdated. Please renew your profile first."
                                      )}
                                    </p>
                                  ) : null
                                }
                              />
                            </div>
                          )}
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="col-4 col-md-5">
                          <div
                            className="skorSetWrapper"
                            style={{ position: "relative" }}
                          >
                            <div
                              className="skorr"
                              style={{
                                filter: "grayscale(1) opacity(0.5)",
                                pointerEvents: "none",
                              }}
                            >
                              <CircularProgressbarWithChildren
                                value={0}
                                maxValue={100}
                                circleRatio={0.78}
                                styles={buildStyles({
                                  rotation: 0.61,
                                  strokeLinecap: "round",
                                  trailColor: "#e6f0e9",
                                  textColor: "#1c1c1c",
                                  pathTransitionDuration: 0.5,
                                  pathColor: "#e6f0e9",
                                })}
                              >
                                <div className="skills">
                                  <div className="dsk-score">
                                    <div className="dsk-score__value">--</div>
                                    <div className="skoroutoftext dsk-score__max">
                                      /1000
                                    </div>
                                  </div>
                                  <div className="skoreset">
                                    <div className="skorstart dsk-score__tick">
                                      0
                                    </div>
                                    <div className="skorend dsk-score__tick">
                                      1000
                                    </div>
                                  </div>
                                </div>
                              </CircularProgressbarWithChildren>
                            </div>
                          </div>
                        </div>
                        <div className="col-8 col-md-7 skorSetDetailsWrapper d-flex flex-column justify-content-center gap-2">
                          <Badge tone="warning" className="dsk-mismatch-badge">
                            <Icon name="warning" size={14} />
                            {_t(
                              "holder_mismatch_title",
                              "This account is not in your name"
                            )}
                          </Badge>
                          <InfoList
                            items={[
                              {
                                label: _t("accountHolder"),
                                value: accountHolderName,
                              },
                              {
                                label: _t("profileUser"),
                                value: profileUserName,
                              },
                            ]}
                          />
                          <p className="dsk-hint">
                            {_t(
                              "holder_mismatch_subtitle",
                              "The account holder doesn't match your verified identity. Try again with an account in your name."
                            )}
                          </p>
                          {!llShowOnly && !readOnly && (
                            <div
                              style={{ display: "inline-block" }}
                              data-tooltip-id={
                                isProfileOutdated
                                  ? "connect-bank-blocked-tooltip"
                                  : undefined
                              }
                            >
                              <Button
                                className="mt-2"
                                disabled={isProfileOutdated}
                                iconStart={
                                  <img
                                    src={"/images/bank-icon.svg"}
                                    alt=""
                                    onError={(e) =>
                                      (e.target.style.display = "none")
                                    }
                                  />
                                }
                                onClick={() => {
                                  if (isProfileOutdated) return;
                                  setBankshow(true);
                                  setReconnectFlow(true);
                                }}
                              >
                                {_t(
                                  "connectYourBankAccount",
                                  "Connect your bank account"
                                )}
                              </Button>
                              <ReactTooltip
                                id="connect-bank-blocked-tooltip"
                                place="top"
                                className="react-tooltip-styling"
                                render={() =>
                                  isProfileOutdated ? (
                                    <p>
                                      {_t(
                                        "profileOutdatedRenewFirst",
                                        "Your profile is outdated. Please renew your profile first."
                                      )}
                                    </p>
                                  ) : null
                                }
                              />
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </Card>
            </div>
          ) : llShowOnly ? (
            <LandlordBankCard
              showReportIcons={showReportIcons}
              sendRemainderLoading={sendRemainderLoading}
              isUserTenantCheck={isUserTenantCheck}
              handleSendRemainder={handleSendRemainder}
              user={user}
              financial_info_errors={financial_info_errors}
              reportMode={reportMode}
            />
          ) : (
            <ConnectBankCard
              user={user}
              setBankshow={setBankshow}
              isGuarantor={isGuarantor}
              readOnly={readOnly}
              paymentScoreLoading={paymentScoreLoading}
              setReconnectFlow={setReconnectFlow}
              financial_info_errors={financial_info_errors}
              isProfileOutdated={isProfileOutdated}
              processing={processing}
              bankStatementClassification={bankStatementClassification}
            />
          )}
        </div>
      </div>

      <TotalSalaryModal
        isOpen={totalIncomeModal}
        onClose={() => setTotalIncomeModal(false)}
        handleUpdateSource={() => {
          if (reportMode) return;
          setTotalIncomeModal(false);
          setUpdateIncomeSourceModal(true);
        }}
        user={user}
        effortObj={effortObj}
        userIncome={userIncome}
        gurantorsIncome={gurantorsIncome}
        setUpdateSourceObj={{}}
        showReportIcons={showReportIcons}
        llShowOnly={llShowOnly}
        profileId={profileId}
        disabledIncomeSourcesFromDb={excluded_income_source_ids}
        loadFullInfo={loadFullInfo}
        isFromReport={isFromReport}
      />
      {updateIncomeSourceModal && (
        <UpdatedIncomeSourceModal
          show={updateIncomeSourceModal}
          onHide={() => {
            setUpdateIncomeSourceModal(false);
          }}
          updateSourceList={updateSourceObj}
          handleIncomeChange={handleIncomeChange}
          loadFullInfo={loadFullInfo}
          savedCustomSources={fullinfo?.custom_income_sources}
          handleDeleteCustomIncome={handleDeleteCustomIncome}
          isGuarantor={isGuarantor}
        />
      )}
      {Bankshow && (
        <BankModal
          user={user}
          formHandler={() => {}}
          updateUserProfile={updateTenantData}
          isGuarantor={isGuarantor}
          loadGuarantorData={() => {}}
          guarantor_a_id={null}
          usedFor={"popup"}
          setBankshow={setBankshow}
          loadFullInfo={loadFullInfo}
          setPaymentScoreLoading={setPaymentScoreLoading}
          reconnectFlow={reconnectFlow}
          setReconnectFlow={setReconnectFlow}
          getAnalysisDetails={getAnalysisDetails}
          setScoreValue={setScoreValue}
          setFinancial_info_errors={setFinancial_info_errors}
        />
      )}
      <FinancialInfoModal
        user={user}
        finData={user?.tenant_extra_field_id?.tink_report_data}
        isOpen={financialInfoModal}
        onClose={() => setFinancialInfoModal(false)}
        handleFinancialIncomeChange={handleFinancialIncomeChange}
        storedFinancialData={selectedFinancialIncomeSourceData}
        selectedSources={selectedSources}
        setSelectedSources={setSelectedSources}
      />
    </>
  );
};

export default DetailsSkor;
